export default __webpack_public_path__ + "static/flipping-misfits-aaccfbaa329485e4e05ca224f44e3eb6.jpg";